module.exports = __webpack_public_path__ + "static/media/DNA-Report.87f2fec0.svg";